import React, { useEffect, useState } from 'react';
import { Button, Header, Icon, Loader, Message, Segment, Statistic } from 'semantic-ui-react';
import { getLiveMetrics } from '../../services/Metrics';

function MetricsLiveCard() {
  const [state, setState] = useState({
    data: null,
    loading: true,
    error: false,
    lastUpdated: null,
  });

  const fetchLive = () => {
    setState((s) => ({ ...s, loading: true, error: false }));
    getLiveMetrics()
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          setState({
            data: res.data.result,
            loading: false,
            error: false,
            lastUpdated: new Date(),
          });
        } else {
          setState((s) => ({ ...s, loading: false, error: true }));
        }
      })
      .catch(() => setState((s) => ({ ...s, loading: false, error: true })));
  };

  useEffect(() => {
    fetchLive();
  }, []);

  return (
    <Segment className="transparent-table">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Header as="h3" color="teal" style={{ margin: 0 }}>
          <Icon name="signal" />
          <Header.Content>Live</Header.Content>
        </Header>
        <div>
          {state.lastUpdated && (
            <small style={{ opacity: 0.6, marginRight: '1em' }}>
              Mis à jour : {state.lastUpdated.toLocaleTimeString('fr-FR')}
            </small>
          )}
          <Button size="small" icon loading={state.loading} onClick={fetchLive}>
            <Icon name="refresh" />
          </Button>
        </div>
      </div>
      {state.loading && !state.data && (
        <Loader active inline="centered" style={{ marginTop: '1em' }} />
      )}
      {state.error && (
        <Message
          error
          content="Impossible de charger les métriques live."
          style={{ marginTop: '1em' }}
        />
      )}
      {state.data && (
        <Statistic.Group widths={2} size="small" style={{ marginTop: '1em' }}>
          <Statistic>
            <Statistic.Value>{state.data.active_connections ?? '—'}</Statistic.Value>
            <Statistic.Label>Connexions actives</Statistic.Label>
          </Statistic>
          <Statistic>
            <Statistic.Value>{state.data.peak_today ?? '—'}</Statistic.Value>
            <Statistic.Label>Pic aujourd&apos;hui</Statistic.Label>
          </Statistic>
        </Statistic.Group>
      )}
    </Segment>
  );
}

export default MetricsLiveCard;
